
<div
  #scrollContainer
  class="grab-on-hover-wrapper"
  (pointerdown)="startDrag($event)"
  (pointermove)="onDrag($event)"
  (pointerup)="stopDrag($event)"
  (pointercancel)="stopDrag($event)"
  (pointerleave)="stopDrag($event)">

<p-table #dataTable
              [value]="primengTableHelper.records"
              [paginator]="false"
              [rows]="primengTableHelper.defaultRecordsCountPerPage"
              [lazy]="true"
              stripedRows
              [breakpoint]="primengTableHelper.breakpoint"
              [responsiveLayout]="primengTableHelper.responsiveLayout">

      <ng-template #header>
        <tr>
          <th class="text-md-start" id="evaluateeName">
            {{ l('::Evaluatee') }}
          </th>

          <th class="text-md-center" id="evaluationState">
            {{ l('::State') }}
          </th>

          <th class="text-md-end" id="evaluationFinishedDate">
            {{ l('::FinishedDate') }}
          </th>

          @if (this.evaluationGridModel?.isOperatorEvaluationSummaryFlow ?? false) {
            <th class="text-md-start" id="evaluationTemplateVersion">
              {{ l('::Template') }} / {{ l('::Version') }}
            </th>
          }

          @if(!evaluationGridModel?.isCalibrationGrid){
            <th class="text-md-start" id="evaluationType">
              {{ l('::Type') }}
            </th>
          }

          <th class="text-md-start" id="evaluationArea">
            {{ l('::Area') }} / {{ l('::SubArea') }}
          </th>

          <th class="text-md-start" id="evaluationShift">
            {{ l('::Shift') }}
          </th>

          <th class="text-md-end" id="evaluationTotalScore">
            {{ l('::TotalScore') }}
          </th>

          <th class="text-md-center" id="actions">
            {{ l('::Actions') }}
          </th>

        </tr>
      </ng-template>
      <ng-template #body let-evaluation>
        <tr>
          <td class="text-md-start">
            <span class="p-column-title">{{ l('::Evaluatee') }}</span>
            {{ evaluation.evaluateName }}
          </td>

          <td class="text-md-center">
            <span class="p-column-title">{{ l('::State') }}</span>
            <app-evaluation-state-tag [evaluationState]="evaluation.state"></app-evaluation-state-tag>
          </td>

          <td class="text-md-end">
            <span class="p-column-title">{{ l('::FinishedDate') }}</span>
            @if (!isNullOrUndefined(evaluation.finishedDate)) {
              {{ evaluation.finishedDate }}
            } @else {
              {{ Hyphen }}
            }
          </td>

          @if (this.evaluationGridModel?.isOperatorEvaluationSummaryFlow ?? false) {
            <td class="text-md-start">
              <span>{{ evaluation.templateName }}</span>
              <span class="d-block text-muted small">{{ l('::Version') }} {{ evaluation.templateVersion }}</span>
            </td>
          }

          @if (!evaluationGridModel?.isCalibrationGrid) {
            <td class="text-md-start">
              <span class="p-column-title">{{ l('::Type') }}</span>
              <app-evaluation-type-column [evaluationType]="evaluation.type"></app-evaluation-type-column>
            </td>
          }

          <td class="text-md-start">
            <div>
              <span>{{ evaluation.areaName }}</span>
              <span class="d-block text-muted small">{{ evaluation.subAreaName }}</span>
            </div>
          </td>

          <td class="text-md-start">
            <span class="p-column-title">{{ l('::Shift') }}</span>
            {{ evaluation.shiftName }}
          </td>

          <td class="text-md-end">
            <span class="p-column-title">{{ l('::TotalScore') }}</span>
            {{ isEvaluationActive(evaluation.state) ? Hyphen : evaluation.totalScore }}
          </td>

          @if (canEditEvaluation(evaluation)) {
            <td class="text-md-center">
              <span class="p-column-title">{{ l('::Actions') }}</span>
                @if (isEvaluationActive(evaluation.state)) {
                  <app-edit-icon-button
                    (triggered)="onEditEvaluation(evaluation.evaluationInstanceId)">
                  </app-edit-icon-button>
                } @else {
                  <app-view-icon-button
                    (triggered)="onViewEvaluation(evaluation.id)">
                  </app-view-icon-button>
                }
            </td>
          } @else{
            @if (!isEvaluationActive(evaluation.state)) {
              <td class="text-md-center">
                <span class="p-column-title">{{ l('::Actions') }}</span>
                <app-view-icon-button 
                  (triggered)="onViewEvaluation(evaluation.id)">
                </app-view-icon-button>
              </td>
            } @else {
              <td class="text-md-center">
                <span class="p-column-title">{{ l('::Actions') }}</span>
                {{ Hyphen }}
              </td>
            }
          }
        </tr>
      </ng-template>

    </p-table>

    @if (!primengTableHelper.totalRecordsCount) {
      <div class="primeng-no-data">
        {{ l('::NoData') }}
      </div>
    }

    <div class="primeng-paging-container">
      <p-paginator
        [rows]="primengTableHelper.defaultRecordsCountPerPage" #paginator
        [totalRecords]="primengTableHelper.totalRecordsCount"
        [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
        [showCurrentPageReport]="true"
        (onPageChange)="getEvaluations($event)"
        [currentPageReportTemplate]="l('::TotalRecordsCount', primengTableHelper.totalRecordsCount)">
      </p-paginator>
    </div>

</div>
